import React from 'react';
import { GiftLiteIcon, Icon } from '@klickly/front-packages';
import { StyledTitle, StyledWrapper } from './styled';

function NoRewardsAvailable() {
    return (
        <StyledWrapper>
            <Icon size='80px' component={() => <GiftLiteIcon />} />
            <StyledTitle level={3} type='descriptor1'>
                No Rewards available
            </StyledTitle>
        </StyledWrapper>
    );
}

export default NoRewardsAvailable;
